// Texts for the PBF inventory settings (quota, blocked items, near-expiry).
// Fields missing from an older backend mean: buyable, no quota, no near-expiry.

// Fixed short months: moment's "id" locale writes "Agt" instead of "Agu".
const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "Mei",
  "Jun",
  "Jul",
  "Agu",
  "Sep",
  "Okt",
  "Nov",
  "Des",
];

// Business refusals of cart add/update and checkout submit (HTTP 409).
const REFUSAL_CODES = [
  "PRODUCT_INACTIVE",
  "PRODUCT_NO_ACCESS",
  "QUOTA_EXCEEDED",
  "STOCK_INSUFFICIENT",
  "CHECKOUT_IN_PROGRESS",
];

export const BLOCKED_ITEM_LINE =
  "Ada barang yang tidak bisa dibeli. Kurangi jumlah atau hapus centang.";

export const formatEdDate = (date) => {
  const [year, month, day] = date.split("-");
  return `${Number(day)} ${MONTHS[Number(month) - 1]} ${year}`;
};

export const quotaListLabel = (quota) =>
  `Sisa kuota: ${quota.remaining} ${quota.uom}/bulan`;

export const quotaDetailLabel = (quota) =>
  `Kuota bulanan: ${quota.monthly_quota} ${quota.uom} · Terpakai ${quota.used} · Sisa ${quota.remaining} ${quota.uom}`;

export const quotaCartLabel = (quota) =>
  `Sisa kuota bulan ini: ${quota.remaining} ${quota.uom}`;

export const quotaCapHint = (quota) =>
  `Maksimal sisa kuota bulan ini: ${quota.remaining} ${quota.uom}`;

export const nearExpiryLabel = (nearExpiry, qty, uom) =>
  `⚠ ${
    nearExpiry.units === qty
      ? `Semua ${qty}`
      : `${nearExpiry.units} dari ${qty}`
  } ${uom} ED kurang dari 1 tahun (ED terdekat ${formatEdDate(
    nearExpiry.earliest_ed,
  )})`;

export const nearExpiryLine = (item) =>
  `${item.name} — ${item.near_expiry.units} ${item.uom}, ED ${formatEdDate(
    item.near_expiry.earliest_ed,
  )}`;

// The app does not subtract what is already in the cart; the backend does.
export const stepperMax = (stock, quota) =>
  quota ? Math.min(stock, quota.remaining) : stock;

export const isPbfRefusal = (err) =>
  REFUSAL_CODES.includes(err?.detail?.error_code);

// A checked item the backend marked as not buyable blocks "Beli" / "Bayar Sekarang".
export const hasBlockedCheckedItem = (items) =>
  (items || []).some(
    (item) => item.is_checked !== false && item.buyable === false,
  );
